import type { MetaDescriptor } from '@remix-run/node';
import { getPreloadImageLink } from '@modules/images';
import type { SearchResultItem, SearchResults } from '@modules/search';
import { getProfessionalTileThumbnail } from '~/utils';
import { getProjectTileImage } from '~/modules/search/util/elasticsearch-project-tile-view';

export const prefetchCategoryImages = (
    hits: SearchResults<SearchResultItem>['hits'],
    numberTilesToPreload = 2,
    imageSizes: string,
    isMobile = false
): MetaDescriptor[] => {
    if (!hits) return [];

    return hits.slice(0, numberTilesToPreload).reduce((acc, hit) => {
        const imageUrl = getPrefetchCategoryImageBasedOnType(hit, isMobile);
        if (!imageUrl) return acc;
        const link = isMobile
            ? getPreloadImageLink(undefined, imageUrl, imageSizes)
            : getPreloadImageLink(imageUrl, undefined, imageSizes);
        return acc.concat(link);
    }, [] as MetaDescriptor[]);
};

const getPrefetchCategoryImageBasedOnType = (
    hit: SearchResultItem,
    isMobile: boolean
): string => {
    if (hit.PType === 'Professional') {
        return getProfessionalTileThumbnail(hit, isMobile);
    } else if (hit.PType === 'Project') {
        return getProjectTileImage(hit, isMobile)[0] ?? '';
    }

    return hit.DirectoryTile?.Thumb ?? hit.Thumb_lg ?? '';
};
